module.exports = __webpack_public_path__ + "static/media/03.cd035fbc.png";